import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Lor95 Boutique";
const SITE_URL = "https://lor95.com";
const DEFAULT_IMAGE = `${SITE_URL}/lor95.png`;

export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  structuredData = null
}) {
  const fullTitle =
    title === SITE_NAME
      ? SITE_NAME
      : `${title} | ${SITE_NAME}`;

  const canonicalUrl =
    path === "/"
      ? SITE_URL
      : `${SITE_URL}${path}`;

  return (
    <Helmet>
      <html lang="sq" />

      <title>{fullTitle}</title>

      <meta
        name="description"
        content={description}
      />

      <link
        rel="canonical"
        href={canonicalUrl}
      />

      {noindex && (
        <meta
          name="robots"
          content="noindex, nofollow"
        />
      )}

      {!noindex && (
        <meta
          name="robots"
          content="index, follow"
        />
      )}

      <meta
        property="og:type"
        content={type}
      />

      <meta
        property="og:title"
        content={fullTitle}
      />

      <meta
        property="og:description"
        content={description}
      />

      <meta
        property="og:url"
        content={canonicalUrl}
      />

      <meta
        property="og:image"
        content={image}
      />

      <meta
        property="og:site_name"
        content={SITE_NAME}
      />

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={fullTitle}
      />

      <meta
        name="twitter:description"
        content={description}
      />

      <meta
        name="twitter:image"
        content={image}
      />

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
